import { useWidgetContext } from 'widgets/WidgetContext';
import { useSelectLocked } from 'layoutRenderer/store/selectors';
import { styleConstants } from './variables.module.constants';
import { useIntraDayProfileConfigSlice } from 'widgets/intraDayProfile/store/configuration/configSlice';
import { useIntradayProfileLegendStatus } from 'widgets/intraDayProfile/legend/legendStatus';

export interface UseIntradayProfileDimensionsRet {
    hideLegends: boolean;
    headerHeight: number;
    chartTop: number;
    chartHeight: number;
    minLegendsWidth: number;
    minLegendsEditingWidth: number;
}
export function useIntradayProfileDimensions(): UseIntradayProfileDimensionsRet {
    const { height } = useWidgetContext();
    const { config } = useIntraDayProfileConfigSlice();

    const locked = useSelectLocked();

    const { hideToolbar } = config;

    const { hidingAllLegends, rows, columns } =
        useIntradayProfileLegendStatus();
    const hideLegends = locked && hidingAllLegends;

    let headerHeight = 0;

    if (locked) {
        if (hidingAllLegends) {
            if (!hideToolbar) {
                headerHeight = styleConstants.toolbarHeight;
            }
        } else {
            const legendsHeight = rows * styleConstants.legendHeight;

            headerHeight = Math.max(
                styleConstants.toolbarHeight,
                legendsHeight
            );
        }
    } else {
        headerHeight = 2 * styleConstants.legendHeight;
    }

    const chartHeight = height - headerHeight - styleConstants.spaceAround * 2;
    const chartTop = headerHeight + styleConstants.headerMargin;

    const minLegendsWidth = locked
        ? columns * styleConstants.minLegendWidth
        : 4 * styleConstants.minLegendWidth;
    const minLegendsEditingWidth = 4 * styleConstants.minLegendEditingWidth;

    return {
        hideLegends,
        headerHeight,
        chartHeight,
        chartTop,
        minLegendsWidth,
        minLegendsEditingWidth,
    };
}
